// import assert from "assert";
import { REACT_APP_API_URL } from '../../../_config/env';

// Block the build if this variable is not found
// This avoid us to ship a broken app in case of env error
// assert(REACT_APP_API_URL, "env variable not set: REACT_APP_API_URL");

// Fonction utilitaire pour nettoyer les doubles slashes dans les URLs
function cleanUrl(url: string): string {
  // Remplacer tous les doubles slashes par un seul, sauf après le protocole (http:// ou https://)
  return url.replace(/([^:]\/)\/+/g, '$1');
}

// Fonction pour joindre les parties d'URL proprement
function joinUrl(...parts: string[]): string {
  const joined = parts
    .map((part, index) => {
      // Enlever le slash de fin sauf pour la dernière partie
      if (index < parts.length - 1) {
        part = part.replace(/\/+$/, '');
      }
      // Enlever le slash de début sauf pour la première partie
      if (index > 0) {
        part = part.replace(/^\/+/, '');
      }
      return part;
    })
    .join('/');
  
  return cleanUrl(joined);
}

// Nettoyer l'URL de base en enlevant le slash final s'il existe
const cleanBaseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

export const API_URL_PRD = cleanBaseUrl;
export const API_BASE_PATH = "/api/";
export const API_PUBLIC_PATH = "/api/public/";
export const API_PROTECTED_PATH = "/api/protected/";
export const API_CLIENTS_MAP = {
  SOS: 'SOS',
} as const;

export type ApiClientType = keyof typeof API_CLIENTS_MAP;

export const API_SOS_ROUTES: {[key: string]: string} = {
  BASE: joinUrl(REACT_APP_API_URL || '', API_BASE_PATH),
  PUBLIC: joinUrl(REACT_APP_API_URL || '', API_PUBLIC_PATH),
  PROTECTED: joinUrl(REACT_APP_API_URL || '', API_PROTECTED_PATH),
  LOGOUT: "/users/logout",
}

// Exporter les fonctions utilitaires pour une utilisation ailleurs
export { cleanUrl, joinUrl };

// from mobile app
// const API_URL_PRD = "https://app-fr.one-smile.care"; --> in env file
//const API_URL_PRD = "http://192.168.0.36:8000";

// const API_PUBLIC_PATH = "/api/public/";
// const API_PROTECTED_PATH = "/api/protected/";

